import { useParams } from "react-router";
import "./index.less";
import { PMaterial } from "@/commons/interface/speccommon/material";
import { useState, useEffect, useContext, useRef, forwardRef } from "react";
import { ReactComponent as PlusSvg } from '@/commons/icons/ope/plus.svg';
import { ReactComponent as CloseSvg } from '@/commons/icons/ope/close.svg';
import { ReactComponent as DeleteSvg } from '@/commons/icons/side-bar/side-delete.svg';
import { ReactComponent as SaveSvg } from '@/commons/icons/side-bar/side-save.svg';
import { ReactComponent as CancelSvg } from '@/commons/icons/side-bar/side-cancel.svg';
import { ReactComponent as CheckSvg } from '@/commons/icons/side-bar/side-check.svg';
import { ReactComponent as CheckedSvg } from '@/commons/icons/side-bar/side-checked.svg';
import { ReactComponent as JoinSvg } from '@/commons/icons/side-bar/side-join.svg';
import { getMaterialsByprojectUuid, updateMaterial, addProjectMaterial, addCustomMaterial, deleteProjectMaterialMulti, checkMaterialsHasBeenUsed } from "@/api/spec-common/material";
import { Input, message, Modal, Skeleton } from "antd";
import TnModal from "@/commons/widget/base-modal";
import MaterialDetail from "./material-detail";
import MaterialSelfdefine from "./material-selfdefine";
import MaterialLib from "./material-lib";
import { SideStatus } from "@/commons/context/side-store";
import { HavcContext, SideContext, StructureContext } from "@/App";
import { StructureStatus } from "@/commons/context/structure-store";
import { MAJOR, getMajorName } from "@/commons/constants/major";
import { HavcStatus } from "@/commons/context/havc-store";
import localStore from "@/commons/store/local-store";
import axios from "axios";
interface Iprops {
    width: number;
}

const LibChild = forwardRef(MaterialLib);
const SelfChild = forwardRef(MaterialSelfdefine);
const DetailChild = forwardRef(MaterialDetail);

export default function ProMaterialPanel(props: Iprops) {
    const { projectUuid } = useParams();
    const [selPMat, setSelPMat] = useState<PMaterial>(null);
    // const [contextMenuVisible, setContextMenuVisible] = useState<boolean>(false); // 右键菜单是否打开
    // const [cmTop, setCmTop] = useState<number>(); //下拉框上方定位
    // const [cmLeft, setCmLeft] = useState<number>(); //下拉框左侧定位
    // const [contextTopMenuVisible, setContextTopMenuVisible] = useState<boolean>(false); // 顶部添加菜单
    // const [ctmTop, setCtmTop] = useState<number>();
    // const [ctmLeft, setCtmLeft] = useState<number>();
    const [mode, setMode] = useState<'list' | 'lib' | 'selfdefine' | 'detail'>('list');
    const [loading, setLoading] = useState<boolean>(false);
    const sideContext = useContext<SideStatus>(SideContext);
    const [deleting, setDeleting] = useState<boolean>(false); // 处于删除状态中
    const [selectedMaterials, setSelectedMaterials] = useState<PMaterial[]>([]); // 删除的选中项
    const [editId, setEditId] = useState<string>('');
    const [editName, setEditName] = useState<string>('');

    const structureContext = useContext<StructureStatus>(StructureContext);
    const havcContext = useContext<HavcStatus>(HavcContext);

    const libRef = useRef(null)
    const selfRef = useRef(null)
    const detailRef = useRef(null)

    useEffect(() => {
        setLoading(true);
        getMaterialsByprojectUuid(projectUuid, sideContext.selectedMajorUuid).then((res) => {
            const pMats: PMaterial[] = res.data || [];
            // setDisplayMats(pMats);
            if (sideContext.selectedMajorUuid === MAJOR.STRUCTURE) {
                structureContext.setMaterials(pMats);
            } else if (sideContext.selectedMajorUuid === MAJOR.HVAC) {
                havcContext.setMaterials(pMats);
            }
            if (pMats?.length > 0) {
                setSelPMat(pMats[0]);
            }
        }).catch(() => {
            message.error("获取项目材料列表失败");
        }).finally(() => {
            setLoading(false);
        })
    }, [projectUuid, sideContext.selectedMajorUuid])

    const handleAddFromLib = (materials) => {
        // 库添加
        if (materials.length === 0) {
            return;
        }
        let duplicates = [];
        let uniques = [];
        let oldMaterials = sideContext.selectedMajorUuid === MAJOR.STRUCTURE ? structureContext.materials : havcContext.materials;
        materials.map(item => {
            if (oldMaterials?.some(smt => (smt.isSelfDefined === false) && smt.markId.toString() === item)) {
                duplicates.push(item);
            } else {
                uniques.push(item);
            }
        })
        if (duplicates.length > 0) {
            message.info("已过滤重复材料");
        }
        if (uniques?.length === 0) {
            setMode('list');
            return;
        }
        addProjectMaterial(projectUuid, uniques, sideContext.selectedMajorUuid).then((res) => {
            if (res.data) {
                if (sideContext.selectedMajorUuid === MAJOR.STRUCTURE) {
                    structureContext.setMaterials([...structureContext.materials, ...res.data]);
                } else if (sideContext.selectedMajorUuid === MAJOR.HVAC) {
                    havcContext.setMaterials([...havcContext.materials, ...res.data])
                }
                message.success("添加成功");
            }
        }).catch(() => {
            message.error("添加失败");
        }).finally(() => {
            setMode('list');
        })
    }

    const handleAddSelfdefine = (material: PMaterial) => {
        if (material.name == null || material.name === '') {
            message.error("材料名称不能为空");
            return;
        }
        const newMaterial = { ...material, isSelfDefine: true };
        // 遍历params对象,将数值类型的属性乘以1000000
        for (let param in newMaterial.params) {
            if (material.params[param] == null || material.params[param] === '') {
                message.error("材料参数不能为空");
                return;
            }
            if (typeof newMaterial.params[param] === 'number') {
                newMaterial.params[param] *= 1000000;
            }
        }
        // 自定义
        addCustomMaterial(projectUuid, newMaterial, sideContext.selectedMajorUuid).then((res) => {
            if (res.data) {
                // 在末尾添加元素
                if (sideContext.selectedMajorUuid === MAJOR.STRUCTURE) {
                    const newList = [...structureContext.materials];
                    newList.push({ ...newMaterial, ...res.data });
                    structureContext.setMaterials(newList);
                } else if (sideContext.selectedMajorUuid === MAJOR.HVAC) {
                    const newList = [...havcContext.materials];
                    newList.push({ ...newMaterial, ...res.data });
                    havcContext.setMaterials(newList);
                }
                message.success("自定义添加成功");
            }
        }).catch(() => {
            message.error("自定义添加失败");
        }).finally(() => {
            setMode('list');
        })
    }

    const handleUpdate = (material: PMaterial, params: { name: string; value: string; key: string; }[]) => {
        if (material.name == null || material.name === '') {
            message.error("材料名称不能为空");
            return;
        }
        for (const param of params) {
            if (param.value == null || param.value === '') {
                message.error(`${param.name}材料参数不能为空`);
                return;
            }
            const amplifiedValue = parseFloat(param.value) * 1000000;
            if (material.params && material.params.hasOwnProperty(param.key)) {
                material.params[param.key] = amplifiedValue;
            }
        }
        // 拿到编辑后的数据
        updateMaterial(material.id, material).then((res) => {
            if (res.data) {
                if (sideContext.selectedMajorUuid === MAJOR.STRUCTURE) {
                    // 找到下标
                    const index = structureContext.materials.findIndex(item => item.id === material.id);
                    // 替换元素
                    const newList = [...structureContext.materials];
                    newList.splice(index, 1, material);
                    structureContext.setMaterials(newList);
                } else if (sideContext.selectedMajorUuid === MAJOR.HVAC) {
                    // 找到下标
                    const index = havcContext.materials.findIndex(item => item.id === material.id);
                    // 替换元素
                    const newList = [...havcContext.materials];
                    newList.splice(index, 1, material);
                    havcContext.setMaterials(newList);
                }

                message.success("编辑成功");
            }
        }).catch(() => {
            message.error("编辑失败");
        }).finally(() => {
            setMode('list');
        })
    }

    const onCloseClick = (e) => {
        if (mode == 'list') {
            if (sideContext.lastPanel === 'component-assemble') {
                sideContext.setSelectedPanelValue('component-assemble');
            } else {
                sideContext.setSelectedPanelValue(null);
            }
            sideContext.setLastPanel(null);
        } else {
            setMode('list');
        }
    }

    let timer;

    const handleDoubleClick = (material) => {
        clearTimeout(timer);

        setEditId(material.id);
        setEditName(material?.name || '');
    };

    const deleteMaterials = () => {
        if (!selectedMaterials || selectedMaterials?.length === 0) {
            setDeleting(false);
            return;
        }
        TnModal().deleteModal({
            closable: false,
            onOk() {
                let ids: string[] = selectedMaterials?.map(item => item.id);
                let promiseList = []
                if (sideContext.selectedMajorUuid === MAJOR.STRUCTURE) {
                    promiseList.push(checkMaterialsHasBeenUsed(projectUuid, ids, "STRUCTURE"))
                } else if (sideContext.selectedMajorUuid === MAJOR.HVAC) {
                    promiseList.push(checkMaterialsHasBeenUsed(projectUuid, ids, 'HVAC'))
                }
                axios.all(promiseList).then(resList => {
                    let res = resList[0]
                    if (res.status === 200) {
                        let usedIds: string[] = res.data || [];
                        let canRemoveIds = ids?.filter(item => !usedIds.includes(item));

                        if (canRemoveIds?.length > 0) {

                            deleteProjectMaterialMulti(projectUuid, canRemoveIds).then((res) => {
                                if (res.data) {
                                    let msgStr = `${canRemoveIds?.length}个材料删除成功`;
                                    if (usedIds?.length > 0) {
                                        msgStr = msgStr.concat(`；${usedIds?.length}个材料未删除，存在构件使用该材料`)
                                    }
                                    message.success(msgStr);
                                    if (sideContext.selectedMajorUuid === MAJOR.STRUCTURE) {
                                        const newList = structureContext.materials.filter((item) => !canRemoveIds?.some(i => i === item.id));
                                        structureContext.setMaterials(newList);
                                    } else if (sideContext.selectedMajorUuid === MAJOR.HVAC) {
                                        const newList = havcContext.materials.filter((item) => !canRemoveIds?.some(i => i === item.id));
                                        havcContext.setMaterials(newList);
                                    }
                                    setDeleting(false);
                                    setSelectedMaterials([]);
                                    return;
                                }
                            }).catch(() => {
                                message.error("删除失败");
                            }).finally(() => {
                                Modal.destroyAll();
                            });

                        } else {
                            message.error(`删除失败，所有材料均有构件使用`);
                            Modal.destroyAll();
                        }
                    }
                }).catch(() => {
                    Modal.destroyAll();
                })
            },
            onCancel() {
                Modal.destroyAll();
            },
        });
    }

    const inputBlur = (material: PMaterial) => {
        if (editName == null || editName === "") {
            message.error("名称不能为空");
            setEditId('');
            setEditName('');
            return;
        }
        const handleEdit = (materials, setMaterials) => {
            let newArr = [...materials];
            let idx = newArr?.findIndex(item => item.id === material.id);
            if (materials[idx].name == editName) {
                setEditId('');
                setEditName('');
                return;
            }
            let newObj = { ...newArr[idx] };
            newObj.name = editName;
            newArr[idx] = newObj;
            setMaterials(newArr);
            updateMaterial(newObj.id, newObj).then(res => {
                if (res.status === 200) {
                    message.success("编辑成功");
                }
            }).catch(err => {
                message.error("编辑失败");
            }).finally(() => {
                setEditId('');
                setEditName('');
            });
        };

        if (sideContext.selectedMajorUuid === MAJOR.STRUCTURE) {
            handleEdit(structureContext.materials, structureContext.setMaterials);
        } else if (sideContext.selectedMajorUuid === MAJOR.HVAC) {
            handleEdit(havcContext.materials, havcContext.setMaterials);
        }



    }

    const checkClick = (mat: PMaterial) => {
        let newArr = [...selectedMaterials] || [];
        let idx = newArr?.findIndex(item => item.id === mat.id);
        if (idx > -1) {
            newArr.splice(idx, 1);
        } else {
            newArr.push(mat);
        }
        setSelectedMaterials(newArr);
    }

    const onClickChildAdd = () => {
        if (mode === 'lib') {
            if (libRef.current) {
                libRef.current.handleInsert()
            }
        } else if (mode === "detail") {
            if (detailRef.current) {
                detailRef.current.handleInsert()
            }
        } else if (mode == 'selfdefine') {
            if (selfRef.current) {
                selfRef.current.handleInsert()
            }
        }
    }

    return (
        <Skeleton active loading={loading}>
            <div className="material-panel-container">
                <div className='header'>
                    <div className='name-area'>
                        <div className='name' onClick={() => { setMode('list') }}>材料{`${getMajorName(sideContext.selectedMajorUuid || localStore.getSelectedMajor())}`}</div>
                        {mode === 'lib' && <div className='ellipsis'>{`>添加材料`}</div>}
                        {mode === 'detail' && <div className='ellipsis' style={{ maxWidth: props.width - 110 }}>{`>${selPMat?.name}`}</div>}
                        {mode === 'selfdefine' && <div className='ellipsis' style={{ maxWidth: props.width - 110 }}>{`>自定义`}</div>}
                    </div>
                    <div className='icon-group'>
                        {!deleting && mode === 'list' && <>
                            <DeleteSvg className="icon" onClick={() => setDeleting(true)} />
                            <PlusSvg style={{ cursor: "pointer" }} onClick={(e) => {
                                setMode('lib');
                            }} />
                            <CloseSvg style={{ cursor: "pointer" }} onClick={onCloseClick} />
                        </>}
                        {deleting && <>
                            <SaveSvg style={{ cursor: "pointer" }} onClick={deleteMaterials} />
                            <CancelSvg style={{ cursor: "pointer" }} onClick={() => { setDeleting(false); setSelectedMaterials([]) }} />
                        </>}
                        {!deleting && mode != "list" && (
                            <>
                                <SaveSvg style={{ cursor: "pointer" }} onClick={() => { onClickChildAdd() }} />
                                <CancelSvg style={{ cursor: "pointer" }} onClick={() => { setMode('list') }} />
                            </>
                        )}
                    </div>
                </div>
                <div className='body'>
                    {mode === 'list' &&
                        <div className="material-list">
                            {(sideContext.selectedMajorUuid === MAJOR.STRUCTURE ? structureContext.materials : havcContext.materials)?.map((item, index) => (
                                <div
                                    key={index}
                                    className="item"
                                    // onClick={() => { handleClick(item) }}
                                    onDoubleClick={() => handleDoubleClick(item)}
                                >
                                    {deleting && !selectedMaterials?.some(sf => sf.id === item.id) && <CheckSvg
                                        className='check-icon'
                                        onClick={() => checkClick(item)}
                                    />}
                                    {deleting && selectedMaterials?.some(sf => sf.id === item.id) && <CheckedSvg
                                        className='check-icon'
                                        onClick={() => checkClick(item)}
                                    />}
                                    <div className="content">
                                        {editId !== item.id && <div className="data-name ellipsis">{item.name}</div>}
                                        {editId === item.id && <Input
                                            value={editName}
                                            style={{ height: 22, marginLeft: 8, marginRight: 8 }}
                                            onChange={(e) => setEditName(e.target.value)}
                                            onBlur={() => inputBlur(item)}
                                            autoFocus
                                        />}
                                        <JoinSvg className="join-icon" onClick={() => {
                                            setSelPMat(item);
                                            setMode('detail');
                                            setSelectedMaterials([]);
                                        }} />
                                    </div>

                                </div>
                            ))}
                        </div>}
                    {mode === 'lib' && <LibChild ref={libRef} onAddFromLib={handleAddFromLib} onAddSelfdefine={handleAddSelfdefine} goBack={() => { setMode('list') }} width={props.width} />}
                    {mode === 'selfdefine' && <SelfChild ref={selfRef} onAddSelfdefine={handleAddSelfdefine} goBack={() => { setMode('list') }} width={props.width} />}
                    {mode === 'detail' && <DetailChild ref={detailRef} onUpdate={handleUpdate} material={selPMat} goBack={() => { setMode('list') }} width={props.width} />}
                </div>
            </div>
        </Skeleton >
    )
}